import { apiClient } from './client'

export interface User {
  id: string
  email: string
  first_name: string
  last_name: string
  full_name?: string
  role: 'super_admin' | 'admin' | 'viewer'
  is_active: boolean
  is_verified: boolean
  department?: string
  job_title?: string
  phone?: string
  avatar_url?: string
  last_login_at?: string
  created_at: string
  updated_at: string
}

export interface UserListResponse {
  users: User[]
  total: number
  page: number
  page_size: number
  total_pages: number
}

export interface UserUpdateData {
  first_name?: string
  last_name?: string
  role?: string
  is_active?: boolean
  department?: string
  job_title?: string
  phone?: string
}

export const userApi = {
  // Get users list with pagination and filters
  getUsers: async (params?: {
    page?: number
    page_size?: number
    search?: string
    role?: string
    is_active?: boolean
  }): Promise<UserListResponse> => {
    const response = await apiClient.get('/users/', { params })
    return response.data
  },

  // Get single user
  getUser: async (userId: string): Promise<User> => {
    const response = await apiClient.get(`/users/${userId}`)
    return response.data
  },

  // Get current user
  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get('/users/me')
    return response.data
  },

  // Update user
  updateUser: async (userId: string, data: UserUpdateData): Promise<User> => {
    const response = await apiClient.patch(`/users/${userId}`, data)
    return response.data
  },

  // Delete user
  deleteUser: async (userId: string): Promise<void> => {
    await apiClient.delete(`/users/${userId}`)
  },

  // Change password
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiClient.post('/users/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    })
  },

  // Reset user password (admin only)
  resetUserPassword: async (userId: string, newPassword: string): Promise<void> => {
    await apiClient.post(`/users/${userId}/reset-password`, {
      new_password: newPassword
    })
  },

  // Update user role
  updateUserRole: async (userId: string, role: string): Promise<void> => {
    await apiClient.patch(`/users/${userId}/role`, { role })
  },

  // Get user statistics
  getUserStats: async (): Promise<any> => {
    const response = await apiClient.get('/users/stats')
    return response.data
  }
}